var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.38044 0.536195C6.94263 0.178732 9.48249 0 12 0C14.5189 0 17.0602 0.178935 19.6239 0.536804C21.6155 0.814812 23.1809 2.38041 23.4587 4.37203C23.8196 6.9598 24 9.50245 24 12C24 14.499 23.8193 17.0431 23.458 19.6324C23.1802 21.6236 21.6153 23.1888 19.6242 23.4672C17.0828 23.8224 14.5414 24 12 24C9.46007 24 6.92014 23.8226 4.38021 23.4678C2.38858 23.1895 0.823298 21.6237 0.545839 19.6319C0.181946 17.0197 0 14.4757 0 12C0 9.52564 0.181742 6.98314 0.545225 4.37248C0.822597 2.3803 2.38834 0.814122 4.38044 0.536195Z",
    fill: "#FF0000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_121_49908",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.38044 0.536195C6.94263 0.178732 9.48249 0 12 0C14.5189 0 17.0602 0.178935 19.6239 0.536804C21.6155 0.814812 23.1809 2.38041 23.4587 4.37203C23.8196 6.9598 24 9.50245 24 12C24 14.499 23.8193 17.0431 23.458 19.6324C23.1802 21.6236 21.6153 23.1888 19.6242 23.4672C17.0828 23.8224 14.5414 24 12 24C9.46007 24 6.92014 23.8226 4.38021 23.4678C2.38858 23.1895 0.823298 21.6237 0.545839 19.6319C0.181946 17.0197 0 14.4757 0 12C0 9.52564 0.181742 6.98314 0.545225 4.37248C0.822597 2.3803 2.38834 0.814122 4.38044 0.536195Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_121_49908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1325 9.03671C17.9853 8.4712 17.5515 8.02589 17.0008 7.87476C16.0027 7.6001 12 7.6001 12 7.6001C12 7.6001 7.99728 7.6001 6.9991 7.87476C6.44834 8.02589 6.01459 8.4712 5.86739 9.03671C5.59998 10.0616 5.59998 12.2001 5.59998 12.2001C5.59998 12.2001 5.59998 14.3385 5.86739 15.3635C6.01459 15.929 6.44834 16.3743 6.9991 16.5255C7.99728 16.8001 12 16.8001 12 16.8001C12 16.8001 16.0027 16.8001 17.0008 16.5255C17.5515 16.3743 17.9853 15.929 18.1325 15.3635C18.4 14.3385 18.4 12.2001 18.4 12.2001C18.4 12.2001 18.4 10.0616 18.1325 9.03671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8 14.3999V10.3999L14 12.4L10.8 14.3999Z",
    fill: "#FF0000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.99aa61a2b2a6f69d0ad720c1345471b0.svg";
export { ForwardRef as ReactComponent };